import { useLayoutEffect } from "react";

/** Each routed page owns its browser title; side panels keep the page's title. */
export default function usePageTitle(title: string) {
  const pageTitle = title.trim();
  useLayoutEffect(() => {
    document.title = pageTitle ? `${pageTitle} | Platonic` : "Platonic";
    // Do not leak a departed page's title into redirects or route errors.
    return () => {
      document.title = "Platonic";
    };
  }, [pageTitle]);
}
